
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["longtermUser_svg__icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1024 1024","xmlns":"http://www.w3.org/2000/svg","width":"128","height":"128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M941.97 1024H82.02a64.538 64.538 0 01-64.469-64.492V402.244a64.538 64.538 0 0164.46-64.47h859.948a64.55 64.55 0 0164.482 64.47v557.275a64.55 64.55 0 01-64.482 64.469zm21.486-621.744c0-11.852-9.623-21.498-21.486-21.498H82.02c-11.839 0-21.485 9.646-21.485 21.486v126.655h902.932V402.244zm0 171.663H60.546v385.6c0 11.85 9.647 21.485 21.487 21.485H941.98c11.863 0 21.487-9.635 21.487-21.485v-385.6zm-109.4 147.803h-99.005a20.4 20.4 0 010-40.79h99.006a20.4 20.4 0 110 40.802zm-191.68 0H541.885h21.487a20.4 20.4 0 110-40.79h-21.487 120.493a20.4 20.4 0 110 40.802zm-187.032 0h-99.583a20.4 20.4 0 010-40.79h99.583a20.4 20.4 0 010 40.802zm-192.245 0H180.021a20.4 20.4 0 010-40.79h103.067a20.4 20.4 0 110 40.802zm-103.078 109.65h401.624a20.4 20.4 0 110 40.8H180.021a20.4 20.4 0 010-40.8zM761.7 202.387L565.723 315.541h-89.745l263.286-152.008-63.407-109.82a21.51 21.51 0 00-29.357-7.87L179.377 315.542H93.409L625.014 8.626a64.538 64.538 0 0188.07 23.59L876.652 315.54H827.03L761.7 202.387z"}})])
          )
        }
      }
    